import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';
import useAppUser from '../../../hooks/useAppUser';
import { useHostQualityContext } from '../useHostQualityContext';
import { AirbnbAnalyticsReviewTagResponse } from './types/HostQuality.types';

const useAirbnbReviewTags = () => {
  const { hostQualityFilter } = useHostQualityContext();
  const { agencyUid } = useAppUser();

  const { data: reviewTags, isLoading: isReviewTagsLoading } = useAppQuery(
    ['getReviewTags', hostQualityFilter, agencyUid],
    async () => {
      const response = await API.post<AirbnbAnalyticsReviewTagResponse>(
        `/api/internal/airbnb/analytics/review-tags`,
        {
          propertyUids: hostQualityFilter?.propertyUid
            ? [hostQualityFilter.propertyUid]
            : [],
          ownerUids: hostQualityFilter?.ownerUid
            ? [hostQualityFilter.ownerUid]
            : [],
          locations: hostQualityFilter?.location
            ? [hostQualityFilter.location]
            : [],
          from: hostQualityFilter?.range.startDate.toISOString(),
          to: hostQualityFilter?.range.endDate.toISOString(),
        },
      );
      return response.data;
    },
    {
      enabled: agencyUid != null && !!hostQualityFilter,
    },
  );

  return {
    reviewTags,
    isReviewTagsLoading,
  };
};

export default useAirbnbReviewTags;
